"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiButtonGroup = getMuiButtonGroup;
function getMuiButtonGroup() {
  return {
    defaultProps: {
      disableElevation: true,
      disableFocusRipple: true
    }
  };
}